import PromotionsPage from './subPages/promotions';
import StoreEventsPages from './subPages/storeEvents';
import Products from './subPages/products';
import BrandsPages from './subPages/brands';
import CouponsPages from './subPages/coupons';
import QRPages from './subPages/qrs';
import ExtraSalesPages from './subPages/extrasales';
import PromoCalendar from './subPages/calendar';

const routes = [
  {
    path: '/promotions/*',
    canUse: [],
    Component: PromotionsPage,
  },
  {
    path: '/store_events/*',
    canUse: [],
    Component: StoreEventsPages,
  },
  {
    path: '/products/*',
    canUse: [],
    Component: Products,
  },
  {
    path: '/brands/*',
    canUse: [],
    Component: BrandsPages,
  },
  {
    path: '/coupons/*',
    canUse: [],
    Component: CouponsPages,
  },
  {
    path: '/qrs/*',
    canUse: [],
    Component: QRPages,
  },
  {
    path: '/extrasales/*',
    canUse: [],
    Component: ExtraSalesPages,
  },
  {
    path: '/calendar/*',
    canUse: [],
    Component: PromoCalendar,
  },
];

export default routes;
